import React from "react";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DesignedToPerform() {
  return <section data-section-id="32834" id="global-leaders-in-tailings-geo-engineering" className="dark bg-background text-foreground relative h-screen min-h-[700px] w-full overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618705/img/mining_excavator_dark_pit.png')] bg-cover bg-center bg-no-repeat opacity-60" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent" />
        <div className="absolute inset-0 !bg-transparent !text-transparent !h-[800px]" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 flex flex-col items-center text-center !bg-transparent !text-transparent">
        {}
        <h1 className="font-black tracking-tighter uppercase leading-[0.9] !text-4xl !bg-transparent !text-[hsl(0,0%,100%)]"><br />ALL TAILINGS &amp; GEOTECHNICAL&nbsp;</h1>

        {}
        <p className="mt-6 max-w-2xl text-left text-lg font-medium leading-relaxed !text-[hsl(0,0%,100%)] md:text-2xl">ALL Tailings and Geotechnical Consulting (ATG) provides specialized phosphogypsum, tailings and wastewater oversight, geotechnical project management, and GISTM/ICMM compliance services. <br /><br />We deliver international expertise in environmental monitoring, sustainable water management, risk review, and operational transformation for tailings and impoundment facilities worldwide.<br /><br />&nbsp;Our team supports responsible resource development through best‑practice tailings governance, independent technical review, and sustainable engineering approaches designed for long‑term performance and regulatory compliance.</p>

        {}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base font-bold px-8 h-14 rounded-none uppercase tracking-wide">
            <Link to="/ContactPage">
              Request Technical Consultation
            </Link>
          </Button>

          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base font-bold px-8 h-14 rounded-none uppercase tracking-wide">
            <Link to="/ServicesPage">
              VIEW GLOBAL SERVICES
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 opacity-80">
        <span className="text-xs uppercase tracking-[0.2em] font-semibold !text-black">
          Scroll Down
        </span>
        <div className="h-16 w-[1px] bg-white/20 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-[slide-down_1.5s_infinite]" />
        </div>
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes slide-down {
            0% { transform: translateY(-100%); }
            100% { transform: translateY(200%); }
          }
        `
    }} />
    </section>;
}